import React, { useState } from 'react'
import { Form, Icon, Input, Modal, Row, Select, Upload, Radio, Col, Button } from 'antd'
import axios from 'axios'
import { ButtonEx } from '../../../../styles/button.style'
import UploadImages from '../../../../components/UploadImages'
import { useDeepEffect } from '../../../../utils/hooks'
import { UNIT } from '../../../../utils/constants'
import _, { isNull } from 'lodash'
import { beforeUpload, compressFile, getBase64 } from '../../../../utils/services'
import MaterialAliasSection from '../MaterialAliasSection'

const MaterialForm = (props) => {
  const { visible, onOk, onCancel, formData, form } = props
  const { setFieldsValue, getFieldDecorator, validateFields } = form
  const [productImageUrl, setProductImageUrl] = useState("")
  const [categories, setCategories] = useState([])
  const [coverList, setCoverList] = useState([])
  const [materialId, setmaterialId] = useState(0)

  useDeepEffect(() => {
    if (!_.isEmpty(formData)) {
      setFieldsValue({
        name: formData.name,
        commonName: formData.commonName,
        engName: formData.engName,
        commonEngName: formData.commonEngName,
        categoryId: formData.categoryId,
        unit: formData.unit,
        baseMaterial: formData.baseMaterial,
        circularBin: formData.circularBin,
        allowCustomChild: !!formData.allowCustomChild,
        co2: formData.co2

      })
      setProductImageUrl(formData.productImage)
      fetchCoverList(formData.id)
      setmaterialId(formData.id)
    } else {
      setFieldsValue({
        baseMaterial: false,
        circularBin: false,
        allowCustomChild: false
      })
    }
    fetchCategories()
    return () => {
      form.resetFields()
      setProductImageUrl('')
    }
  }, [formData])

  async function fetchCategories() {
    try {
      const res = await axios.get(
        process.env.REACT_APP_API_ENDPOINT + `/category/all`
      )
      setCategories(res.data.data)
    } catch (err) {
      console.log(err)
    }
  }

  async function fetchCoverList(id) {
    try {
      const res = await axios.get(
        process.env.REACT_APP_API_ENDPOINT + `/material/coverList/${id}`
      )
      setCoverList(res.data.productImages)
    } catch (err) {
      console.log(err)
    }
  }

  async function uploadProductImage(file) {
    try {
      const formData = new FormData()
      formData.append('image', await compressFile(file))
      const res = await axios.post(
        `${process.env.REACT_APP_API_ENDPOINT}/material/image`,
        formData,
        {
          headers: {
            'content-type': 'multipart/form-data',
          }
        }
      )
      return res.data
    } catch (err) {
      return null
    }
  }

  const uploadButton = (
    <div>
      <Icon type="plus" />
      <div className="ant-upload-text">Upload</div>
    </div>
  )

  async function handleChange(info) {
    await getBase64(info.file, (productImageUrl) => {
      setProductImageUrl(productImageUrl)
    })
  }

  function onSubmit(e) {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        const data = {
          name: values.name,
          categoryId: values.categoryId,
          unit: values.unit,
          baseMaterial: values.baseMaterial,
          circularBin: values.circularBin,
          allowCustomChild: !!values.allowCustomChild
        }
        if (values.commonName) {
          data.commonName = values.commonName
        }
        if (values.engName) {
          data.engName = values.engName
        }
        if (values.commonEngName) {
          data.commonEngName = values.commonEngName
        }
        if (values.co2) {
          data.co2 = values.co2
        }
        if (values.productImage) {
          const img = await uploadProductImage(values.productImage.file)
          data.productImage = img.id
        } else {
          // โหมดสร้างใหม่ formData เป็น undefined — ไม่เลือกรูปให้ backend เป็นผู้ตอบว่าต้องมีรูป
          data.productImage = formData ? formData.productImageId : undefined
        }
        if (!_.isEmpty(formData)) {
          data.id = formData.id
        }
        // onOk คืน false เมื่อ backend ปฏิเสธ — คงรูปและค่าที่กรอกไว้ให้แก้ต่อ
        const success = await onOk(data)
        if (success !== false) {
          setProductImageUrl('')
        }
      }
    })
  }

  async function handleRemoveMaterialImage(imgId) {
    try {
      const userToken = localStorage.getItem('user-token')
      const formData = new FormData()
      formData.append('imgId', imgId)
      formData.append('materialId', materialId)
      const res = await axios.post(
        `${process.env.REACT_APP_API_ENDPOINT}/material/deleteCoverList`,
        formData,
        {
          headers: {
            Authorization: userToken,
          }
        }
      )
      fetchCoverList(materialId)
    } catch (error) {
      console.log(error.message)
    }
  }

  async function handleUploadMaterialImage(file) {
    try {
      const userToken = localStorage.getItem('user-token')
      const formData = new FormData()
      formData.append('image', await compressFile(file))
      formData.append('materialId', materialId)
      const res = await axios.post(
        `${process.env.REACT_APP_API_ENDPOINT}/material/coverList`,
        formData,
        {
          headers: {
            Authorization: userToken,
            'content-type': 'multipart/form-data',
          }
        }
      )
      fetchCoverList(materialId)
    } catch (error) {
      console.log(error.message)
    }
  }

  return (
    <Modal
      visible={visible}
      title={`${!_.isEmpty(formData) ? 'Edit ' : 'Create a new '} product`}
      footer={null}
      onCancel={onCancel}
    >
      <Form onSubmit={onSubmit}>
        <Form.Item label="รูปหน้าปก">
          <Row type="flex" justify="center">
            <Col>
              {getFieldDecorator(`productImage`, {
                rules: [
                  {
                    required: isNull(formData),
                    message: 'เลือกรูปภาพ'
                  }
                ]
              })(
                <Upload
                  name="img"
                  listType="picture-card"
                  showUploadList={false}
                  beforeUpload={(file) => beforeUpload(file)}
                  onChange={handleChange}
                >
                  {productImageUrl ? (
                    <img src={productImageUrl} alt="img" style={{ width: '100%' }} />
                  ) : (
                    uploadButton
                  )}
                </Upload>
              )}
            </Col>
          </Row>
        </Form.Item>
        <Form.Item label="ชื่อวัสดุรีไซเคิล">
          {getFieldDecorator(`name`, {
            rules: [
              {
                required: true,
                message: 'กรุณากรอก'
              }
            ]
          })(<Input
            name="name"
            placeholder="ชื่อวัสดุรีไซเคิล" />)}
        </Form.Item>

        <Form.Item label="ชื่ออื่นๆ">
          {getFieldDecorator(`commonName`)
            (<Input
              name="commonName"
              placeholder="ชื่ออื่นๆ" />)}
        </Form.Item>

        {!_.isEmpty(formData) && (
          <MaterialAliasSection materialId={formData.id} />
        )}

        <Form.Item label="English Name">
          {getFieldDecorator(`engName`)
            (<Input
              name="engName"
              placeholder="English Name" />)}
        </Form.Item>

        <Form.Item label="Common English Name">
          {getFieldDecorator(`commonEngName`)
            (<Input
              name="commonEngName"
              placeholder="Common English Name" />)}
        </Form.Item>

        <Form.Item label="กลุ่มวัสดุ">
          {getFieldDecorator(`categoryId`, {
            rules: [
              {
                required: true,
                message: 'กรุณาเลือก'
              }
            ]
          })(
            <Select
              placeholder="เลือกกลุ่มวัสดุ"
              name="categoryId"
            >
              {categories.map(category => (
                <Select.Option key={category.id} value={category.id}>
                  {category.name}
                </Select.Option>
              ))}
            </Select>)}
        </Form.Item>

        <Form.Item label="หน่วย">
          {getFieldDecorator(`unit`, {
            rules: [
              {
                required: true,
                message: 'กรุณาเลือก'
              }
            ]
          })(
            <Select
              placeholder="เลือกหน่วย"
              name="unit"
            >
              {UNIT.map(unit => (
                <Select.Option key={unit} value={unit}>
                  {unit}
                </Select.Option>
              ))}
            </Select>)}
        </Form.Item>

        <Form.Item label="กำหนดเป็นวัสดุพื้นฐานของร้านรับซื้อ">
          {getFieldDecorator(`baseMaterial`, {
            rules: [
              {
                required: true,
                message: 'กรุณาเลือก'
              }
            ]
          })(
            <Radio.Group
              name="baseMaterial"
            >
              <Radio value={true}>ใช่</Radio>
              <Radio value={false}>ไม่</Radio>
            </Radio.Group>)}
        </Form.Item>

        <Form.Item label="กำหนดเป็น Circular Bin">
          {getFieldDecorator(`circularBin`, {
            rules: [
              {
                required: true,
                message: 'กรุณาเลือก'
              }
            ]
          })(
            <Radio.Group
              name="circularBin"
            >
              <Radio value={true} >ใช่</Radio>
              <Radio value={false}>ไม่</Radio>
            </Radio.Group>)}
        </Form.Item>

        <Form.Item
          label="เปิดให้ร้านสร้างสินค้าย่อย"
          extra="ร้านจะสร้างสินค้าของตัวเองใต้วัสดุนี้ได้ เช่น รุ่นโทรศัพท์ หรือกลุ่ม 'อื่นๆ'">
          {getFieldDecorator(`allowCustomChild`, { initialValue: false })(
            <Radio.Group name="allowCustomChild">
              <Radio value={true}>ใช่</Radio>
              <Radio value={false}>ไม่</Radio>
            </Radio.Group>
          )}
        </Form.Item>
        {formData && (
          <Form.Item label="Pictures">
            <UploadImages
              uploadImage={handleUploadMaterialImage}
              removeImage={handleRemoveMaterialImage}
              images={coverList || null}
            />
          </Form.Item>
        )}
        <Form.Item label="CO2">
          {getFieldDecorator(`co2`)
            (<Input
              name="CO2"
              type="number" />)}
        </Form.Item>
        <Row type="flex" gutter={8} justify="end">
          <Col>
            <Button onClick={() => onCancel()}>ยกเลิก</Button>
          </Col>
          <Col>
            <ButtonEx color="#6ebf4b" type="primary" htmlType="submit">
              {`${!_.isEmpty(formData) ? 'Save ' : 'Create'}`}
            </ButtonEx>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

const WrappedMaterialForm = Form.create({
  name: 'MaterialForm'
})(MaterialForm)
export default (WrappedMaterialForm)
